import { NotificationManager } from 'react-notifications';
import { useApiMutation } from '@/hooks/api/useApiMutation';

/** POST `/admin/passwordResetRequest/{email}` — emails a confirmation code. */
export function usePasswordResetRequestMutation() {
  return useApiMutation(
    (email) =>
      `/admin/passwordResetRequest/${encodeURIComponent(email.trim())}`,
    'post',
    {},
    {
      onSuccess: () => {
        NotificationManager.success(
          'Reset instructions sent — check your inbox',
          '',
          4000,
        );
      },
      onError: (err) => {
        NotificationManager.error(
          err.message || 'Could not send reset email',
          '',
          4000,
        );
      },
    },
  );
}
